import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ExamsSection } from './components/ExamsSection';
import { DifferentialsSection } from './components/DifferentialsSection';
import { InsuranceSection } from './components/InsuranceSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ExamsSection />
      <InsuranceSection />
      <DifferentialsSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
